import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useViewOptions from '../../hooks/useViewOptions';
import CommonRadioButton from '../../components/common-radio-button/CommonRadioButton';
import { changeChartView } from '../../redux/sonar/sonarReducer';

import scss from './ViewRadioGroup.module.scss';

function ViewRadioGroup({ section, chartIndex }) {
  const dispatch = useDispatch();

  const viewOptions = useViewOptions();
  const sections = useSelector((state) => state.sonarDashboard.sections);
  const view = sections[section].charts[chartIndex].view;

  const handleChangeView = (newView) => {
    dispatch(changeChartView({ section, chartIndex, view: newView }));
  };

  return (
    <div className={scss.wrapper}>
      <div className={scss.radioButtons}>
        {viewOptions.map(({ value, label }) => (
          <CommonRadioButton
            key={value}
            value={value}
            label={label}
            isActive={view === value}
            onSelect={handleChangeView}
          />
        ))}
      </div>
    </div>
  );
}

export default ViewRadioGroup;
